import { render } from "./VProfile.vue?vue&type=template&id=cb73a67e"
import script from "./VProfile.vue?vue&type=script&lang=js"
export * from "./VProfile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__